import React from 'react';
import Placeholder from '@atlassian/jira-placeholder/src/index.tsx';
import { lazyForPaint } from '@atlassian/react-loosely-lazy';
import type { SupportWebsiteNavOld } from './ui/index.tsx';

const LazySupportWebsiteNav = lazyForPaint<typeof SupportWebsiteNavOld>(
	() =>
		import(/* webpackChunkName: "async-support-site-nav" */ './ui').then(
			({ SupportWebsiteNavOld }) => SupportWebsiteNavOld,
		),
	{
		includeInShellOnlySsrBundle: true,
	},
);

export const AsyncSupportWebsiteNav = (): React.JSX.Element => (
	<Placeholder name="horizontal-csm-support-site-nav" fallback={null}>
		<LazySupportWebsiteNav />
	</Placeholder>
);
